import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import DatePicker from 'react-datepicker'

import Icon from '../../Icons'
import SearchField from '../../FormLegacy/FormFieldsV2/SearchField'
import Filter from '../../Filter/Filter'
import {
  getReservationsStatusFilterOptions,
  getStatusCountText,
  getCustomTimeIntervals,
} from '../helpers'
import { timeIntervals, generateRange } from '../../../helpers/helpers'

const ReservationsNavbar = ({
  search,
  selectedTab,
  dateRange,
  amenityFilters,
  spaceFilters,
  reservationsData,
  spacesForFilter,
  amenitiesForFilter,
  isCSVButtonDisabled,
  setSearch = () => {},
  setDateRange = () => {},
  setSelectedTab = () => {},
  setAmenityFilters = () => {},
  setSpaceFilters = () => {},
  onCSVDownload = () => {},
}) => {
  const { t } = useTranslation(['reservations'])
  const [startDate, endDate] = dateRange
  const [showPicker, setShowPicker] = useState(false)

  const setDates = (value) => {
    setShowPicker(false)
    setDateRange(generateRange(value))
  }

  const intervals = [...getCustomTimeIntervals(t), ...timeIntervals]

  return (
    <div className="reservations-list-navbar">
      <div className="reservations-list-navbar__filters">
        {getReservationsStatusFilterOptions(t).map((tabFilter) => (
          <div
            className={`message-type-filter ${
              selectedTab && tabFilter.id === selectedTab.id ? 'active' : ''
            }`}
            key={tabFilter.id}
            onClick={() => setSelectedTab(tabFilter)}
          >
            {tabFilter.text}
            <span>{getStatusCountText(tabFilter.value, reservationsData)}</span>
          </div>
        ))}
      </div>
      <div className="reservations-list-navbar__filters">
        <DatePicker
          className={'input borderless reservations-date-input'}
          selectsRange={true}
          startDate={startDate}
          endDate={endDate}
          placeholderText={t('reservations:analyticsNavbar.selectTimeRangePlaceholder')}
          isClearable={true}
          onChange={(range) => {
            setDateRange(range)
            range[1] && setShowPicker(false)
          }}
          onClickOutside={(e) => {
            if (intervals.includes(e.target.value)) {
              setDates(e.target.value)
            }
            setShowPicker(false)
          }}
          onCalendarOpen={() => setShowPicker(true)}
        />
        <div
          style={{ display: showPicker ? 'block' : 'none' }}
          className="interval-picker-container"
        >
          <div className="interval-picker">
            <div className="period-title">{t('reservations:analyticsNavbar.period')}</div>
            <div className="intervals-scroll">
              {intervals.map((interval, i) => (
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                  }}
                  key={interval + i}
                  value={interval}
                  className="interval"
                >
                  {interval}
                </button>
              ))}
            </div>
          </div>
        </div>
        <Filter
          placeholder={
            amenityFilters && amenityFilters.length
              ? amenityFilters.map((filter) => filter.text).join(', ')
              : t('reservations:reservationsNavbar.selectAmenityPlaceholder')
          }
          options={amenitiesForFilter}
          disabled={false}
          value={amenityFilters || []}
          name="AmenityFilter"
          variant="borderless"
          onChange={(e) => setAmenityFilters(e.target.value)}
          closeAfterSelect
          additionalClass="reservations-list-filter"
          config={{ multiple: true }}
        />
        <Filter
          placeholder={
            spaceFilters && spaceFilters.length
              ? spaceFilters.map((filter) => filter.text).join(', ')
              : t('reservations:reservationsNavbar.selectSpacePlaceholder')
          }
          options={spacesForFilter}
          disabled={false}
          value={spaceFilters || []}
          name="SpaceFilter"
          variant="borderless"
          onChange={(e) => setSpaceFilters(e.target.value)}
          closeAfterSelect
          additionalClass="reservations-list-filter"
          config={{ multiple: true }}
        />
        <SearchField
          placeholder={t('reservations:reservationsNavbar.searchPlaceholder')}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          additionalClass={'reservations-list-search'}
        />
        <button
          onClick={onCSVDownload}
          className="button button-black-outline"
          disabled={isCSVButtonDisabled}
        >
          <Icon
            icon="arrowDownload"
            fill="none"
            viewBox="0 -2 20 20"
            svgProps={{
              stroke: '#646464',
              strokeWidth: '1.81824',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
          />
          {t('reservations:detailedView.filters.csv')}
        </button>
      </div>
    </div>
  )
}

ReservationsNavbar.propTypes = {
  search: PropTypes.string,
  selectedTab: PropTypes.object,
  dateRange: PropTypes.array,
  amenityFilters: PropTypes.array,
  spaceFilters: PropTypes.array,
  reservationsData: PropTypes.object,
  amenities: PropTypes.array,
  isCSVButtonDisabled: PropTypes.bool,
  setSearch: PropTypes.func,
  setDateRange: PropTypes.func,
  setSelectedTab: PropTypes.func,
  setAmenityFilters: PropTypes.func,
  setSpaceFilters: PropTypes.func,
  onCSVDownload: PropTypes.func,
}

export default ReservationsNavbar
